import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';

const useStyles = createUseStyles((theme: Theme) => ({
  dataItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.4rem',
    background: '#F9F9F9',
    borderRadius: 6,
    padding: '15px 20px',
    position: 'relative',
    width: '100%',
    '&:hover': {
      background: '#f5f4f4'
    }
  },
  dataItem__info: {
    display: 'flex',
    flexDirection: 'column'
  },
  dataItem__label: {
    color: theme.colors.textGrey,
    fontSize: '0.8rem',
    margin: 0
  },
  dataItem__value: {
    fontSize: '0.8rem',
    fontWeight: 500,
    margin: 0
  },
  '@keyframes animateIn': {
    from: {
      transform: 'translate(0px, -50px)',
      opacity: 0
    },
    to: {
      transform: 'translate(0px, -70px)',
      opacity: 1
    }
  },
  dataItem__popup: {
    right: 0,
    padding: '0.7rem',
    zIndex: 1000,
    position: 'absolute',
    color: '#ffffff',
    background: '#000000',
    boxShadow: '2px 2px 20px 0px rgb(0 0 0 / 9%)',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    fontWeight: 400,
    fontSize: 13,
    width: 'fit-content',
    maxWidth: 300,
    opacity: 0,
    animationName: '$animateIn',
    animationDelay: '0.4s',
    animationDuration: '0.3s',
    animationFillMode: 'forwards'
  }
}));

type Props = {
  icon?: IconProp;
  iconColor?: string;
  iconFontSize?: string;
  style?: React.CSSProperties;
  label: string;
  children: any;
  helpText?: string;
  onClick?: () => void;
};

function DataItem(props: Props) {
  const classes = useStyles();
  const [popup, setPopup] = React.useState<
    | {
        x: string | number;
        y: string | number;
      }
    | undefined
  >(undefined);

  return (
    <div
      className={classes.dataItem}
      style={props.style}
      onClick={props.onClick}
      onMouseEnter={(evt) => {
        setPopup({
          x: evt.clientX,
          y: evt.clientY
        });
      }}
      onMouseLeave={() => {
        setPopup(undefined);
      }}
    >
      {props.icon && (
        <FontAwesomeIcon
          icon={props.icon}
          color={props.iconColor}
          style={
            {
              '--fa-primary-color': props.iconColor || '#ffcccc',
              '--fa-secondary-color': props.iconColor || '#ffcccc',
              fontSize: props.iconFontSize || '1.3rem'
            } as any
          }
        />
      )}
      <div className={classes.dataItem__info}>
        <p className={classes.dataItem__value}>{props.children}</p>
        <p className={classes.dataItem__label}>{props.label}</p>
      </div>

      {popup && props.helpText && (
        <div className={classes.dataItem__popup}>{props.helpText}</div>
      )}
    </div>
  );
}

export default DataItem;
